import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useAdminLanguage } from './AdminI18n';

const LanguageSelector = ({ language, onLanguageChange, sx }) => {
  const { t } = useAdminLanguage();
  return (
    <Box sx={{ 
      border: '1px solid #e0e0e0', 
      borderRadius: 1, 
      p: 2, 
      bgcolor: 'background.paper',
      mb: 3,
      ...sx 
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <LanguageIcon color="primary" />
        <Typography variant="h6" color="primary">
          {t('Langue de travail')}
        </Typography>
      </Box>
      
      <FormControl>
        <FormLabel component="legend" sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
          {t('Sélectionnez la version linguistique à administrer')}
        </FormLabel>
        <RadioGroup
          row
          value={language}
          onChange={(e) => onLanguageChange(e.target.value)}
          sx={{ mt: 1 }}
        >
          <FormControlLabel
            value="fr"
            control={<Radio />}
            label={t('Version française')}
          />
          <FormControlLabel
            value="nl"
            control={<Radio />}
            label={t('Version néerlandaise')}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;
